export const CURRENT_USER_LOGIN_FAILURE = 'CURRENT_USER_LOGIN_FAILURE';
export const CURRENT_USER_LOGIN_SUCCESS = 'CURRENT_USER_LOGIN_SUCCESS';
export const CURRENT_USER_LOGOUT = 'CURRENT_USER_LOGOUT';
export const CURRENT_USER_LOGIN_ATTEMPT_FAILED = 'CURRENT_USER_LOGIN_ATTEMPT_FAILED';
export const CURRENT_USER_LOGIN_ATTEMPT_SUCCESS = 'CURRENT_USER_LOGIN_ATTEMPT_SUCCESS';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const LOGOUT_AS_USER_SUCCESS = 'LOGOUT_AS_USER_SUCCESS';
export const LOGIN_AS_USER_SUCCESS = 'LOGIN_AS_USER_SUCCESS';

